import { useEffect, useState } from 'react';
import { SignUpAction } from '@triare/auth-redux/dist/saga/auth/signUp';
import EmailAndPassword from '../../Pages/Auth/SignIn/EmailAndPassword';
import SignIn from '../../Pages/Auth/SignIn';
import SignUp from '../../Pages/Auth/SignUp';
import SignUpContent from '../../Pages/Auth/SignUp/EmailAndPassword';
import ForgotPassword from '../../Pages/Auth/ForgotPassword';
import Information from '../../Pages/Auth/SignUp/Information';

const defaultFn = () => {};

const useAuthModals = () => {
  const [isSignInOpen, setSignInOpen] = useState(false);
  const [isSignUpOpen, setSignUpOpen] = useState(false);
  const [isForgotOpen, setIsForgotOpen] = useState(false);
  const [informationPayload, setInformationPayload] = useState<Partial<SignUpAction>>({});

  const [onCloseAddition, setOnCloseAddition] = useState<() => void>(defaultFn);

  useEffect(() => {
    if (isForgotOpen) {
      setSignInOpen(false);
    }
  }, [isForgotOpen]);

  const handleCloseWrapper = (defaultAction: () => void) => {
    onCloseAddition?.();
    defaultAction();
    setOnCloseAddition(() => defaultFn); // Reset to default after firing
  };

  return {
    openLoginModal: (onClose?: () => void) => {
      // setOnCloseAddition(() => onClose || defaultFn);
      setOnCloseAddition(() => {
        onClose?.();
      });
      setSignInOpen(true);
    },
    content: (
      <>
        <SignIn
          content={EmailAndPassword}
          isOpen={isSignInOpen}
          onClose={() => handleCloseWrapper(() => setSignInOpen(false))}
          isSignUpOpen={isSignUpOpen}
          setSignUpOpen={setSignUpOpen}
          setForgotOpen={() => setIsForgotOpen(true)}
        />
        <SignUp
          content={SignUpContent}
          isOpen={isSignUpOpen}
          onClose={() => handleCloseWrapper(() => setSignUpOpen(false))}
          setSignInOpen={() => setSignInOpen(true)}
          signUpSuccess={(payload) => setInformationPayload(payload)}
        />
        <ForgotPassword
          isOpen={isForgotOpen}
          onClose={() => handleCloseWrapper(() => setIsForgotOpen(false))}
          setSignInOpen={() => setSignInOpen(true)}
        />
        <Information
          prevPayload={informationPayload}
          // email={informationPayload.email}
          isOpen={!!informationPayload?.email}
          onClose={() => handleCloseWrapper(() => setInformationPayload({}))}
          setSignUpOpen={() => setSignUpOpen(true)}
        />
      </>
    ),
  };
};

export default useAuthModals;
